import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    select: {
        "&.MuiPaper-root": {
            maxHeight: "initial !important",
        },
        maxWidth: theme.spacing(35),
    },
}));
